import { Tag } from 'antd';

import styled from 'styled-components';

/**
 * PayableStyles
 *
 * Styled components for payable statements
 */

export const Actions = styled.div`
    padding: 1rem;
    border-top: ${(props) => props.theme.DefaultBorder};
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .statement-action-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 1rem;
    }
`;

export const PaymentTitleContainer = styled.div`
    .payment-title {
        font-size: 0.9rem;
        font-weight: 600;
        text-transform: uppercase;
    }

    small {
        font-weight: 300;
        font-size: 0.7rem;
        text-transform: uppercase;
        line-height: 1em;
        display: block;
    }
`;

export const ContactNameInTitle = styled.div`
    font-weight: 700;
    font-size: 0.875rem;
    text-transform: uppercase;
    margin-bottom: 0.25rem;
    line-height: 1.2;
    word-break: break-word;
`;

export const OnHoldTag = styled(Tag)`
    margin-top: 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
`;
